import { FormGroup, FormParagraph } from '@ksyos/design-system';
import { ActivityType } from '@common/enums';
import { formatString } from '@common/utils/formatString';
import { formatLogMutation } from '@frontend/components/pages/processes/adminProcessFinancials/utils/formatLogMutation';
import { getSelectedLanguage } from '@frontend/translate';
import type { FinancialLogMutation } from './FinancialSectionOld';

type PaymentInformationForActivityProps = {
    activityType: ActivityType;
    financialLogMutations: FinancialLogMutation[];
};

export function PaymentInformationForActivity({
    financialLogMutations,
    activityType,
}: PaymentInformationForActivityProps) {
    const translate = getSelectedLanguage();

    let condition: (logMutation: FinancialLogMutation) => boolean;

    switch (activityType) {
        case ActivityType.request:
            condition = (logMutation) => logMutation.requestId !== null;
            break;
        case ActivityType.biometrics:
            condition = (logMutation) => logMutation.procedureId !== null;
            break;
        case ActivityType.qualityControl:
            condition = (logMutation) => logMutation.supervisionId !== null;
            break;
        case ActivityType.grading:
        case ActivityType.consultation:
            condition = (logMutation) => logMutation.diagnosticReportId !== null;
            break;
        default:
            condition = () => false;
    }

    const label = formatString(translate.request.payoutSetTo, [translate.activityTypeEnum[activityType]]);
    const formattedLogMutation = formatLogMutation(financialLogMutations.find(condition));

    return (
        <FormGroup label={label}>
            <FormParagraph>
                {translate.request.unpaid} {formattedLogMutation}
            </FormParagraph>
        </FormGroup>
    );
}
